angular.module("khUtils").factory("KhutilsFieldPlotCropFactory", ["$resource", function ($resource) {
    return $resource('/api/v1.0/khutils/fieldplotcrops/:field_plot_crop_slug', {}, {
        query: {
            params: {farm: '@farm', field: '@field', growing_season: '@growing_season', team: '@team'},
            url: '/api/v1.0/khutils/fieldplotcrops/',
            isArray: true
        }
    });
}]);